/*
 * React 19 removed defaultProps support for function components.
 *
 * This reproduces the old semantics exactly: a default is applied when the
 * incoming prop is undefined, including when it was passed explicitly as
 * undefined. (A plain `{ ...defaults, ...props }` spread would not — an
 * explicit `undefined` would win over the default.)
 *
 * `D extends Partial<P>` keeps the defaults honest: a default that the prop
 * type does not allow is a compile error. Every key the defaults cover comes
 * back non-optional, so the component body can read it without a null check.
 */
export function withDefaults<P extends object, D extends Partial<P>>(
  props: P,
  defaults: D
): P & Required<Pick<P, Extract<keyof D, keyof P>>> {
  const merged = { ...props } as Record<string, unknown>;
  for (const key of Object.keys(defaults)) {
    if (merged[key] === undefined) {
      merged[key] = (defaults as Record<string, unknown>)[key];
    }
  }
  return merged as P & Required<Pick<P, Extract<keyof D, keyof P>>>;
}
